export default __webpack_public_path__ + "static/media/person_1.dde90146.png";